import { Button, Card, Divider, Space } from 'antd';
import React, { useMemo } from 'react';
import Validation from './Validation';
import { DynamicObjectType } from 'types/commons';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/pro-light-svg-icons';
import { useDispatch, useSelector } from '@redux';
import crudActions from '@redux/crudActions';
import TotalOrderItem from '../components/TotalOrderItem';
import RelatedOrders from './RelatedOrders';

const HAS_EDIT_SHIPPING_ADDRESS = [
  // {
  //   value: 'AWAITING_CONFIRMATION',
  // },
];

const RightContent = ({ data }: { data: DynamicObjectType }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const address = useSelector<DynamicObjectType[]>(
    (state) => state.config.address,
  );

  const province = useMemo(
    () => address?.find((e) => e.id === data?.location?.provinceId)?.name,
    [address, data],
  );

  return (
    <Space size={20} direction="vertical" className="w-full">
      {data?.statusOms === 'AWAITING_CONFIRMATION' && (
        <Validation data={data} />
      )}
      {data?.statusOms !== 'AWAITING_CONFIRMATION' && (
        <RelatedOrders data={data} />
      )}
      <Card title={t('orderDetail.customerInfor')}>
        <div>
          <div className="order-info-box__content">
            <div className="order-info-box__content-item color-dark-gray mb-[5px]">
              {data?.customer
                ? `${data?.customer?.firstName} ${data?.customer?.lastName}`
                : data?.address?.customerName ||
                  `${data?.address?.firstName} ${data?.address?.lastName}`}
            </div>
            <div className="order-info-box__content-item color-dark-gray opacity-50 mb-[5px]">
              {data?.customer?.email || data?.address?.email}
            </div>
            <div className="order-info-box__content-item color-dark-gray opacity-50">
              {data?.customer?.telephone || data?.address?.telephone}
            </div>
          </div>
        </div>
      </Card>
      <Card
        title={t('orderDetail.pickupInformation')}
        {...(HAS_EDIT_SHIPPING_ADDRESS.find(
          (e: DynamicObjectType) =>
            e.value === data?.statusOms &&
            (!e.addition || data?.[e?.addition?.field] === e?.addition?.value),
        ) &&
          !data?.deliveryCode && {
            // && checkRole('orders/[\\d\\w_]+$', user?.rolePermission, 'PATCH', user?.role === 'bypass')
            extra: (
              <Button
                onClick={() =>
                  dispatch(
                    crudActions.modal.toogleModal({
                      editPickup: { isOpen: true },
                    } as any),
                  )
                }
                type="text"
                icon={<FontAwesomeIcon icon={faPenToSquare} />}
              />
            ),
          })}
      >
        <div>
          <div className="order-info-box__content">
            <div className="order-info-box__content-item fw-600 color-dark-gray mb-[5px]">
              {t('ordersTabTryBuy.pickupProvinceCity')}: {province}
            </div>
            <div className="order-info-box__content-item fw-600 color-dark-gray mb-[5px]">
              {data?.location?.name}
            </div>
            <div className="order-info-box__content-item color-dark-gray opacity-50 mb-[5px]">
              {data?.location?.addressLine}
            </div>
            <div className="order-info-box__content-item color-dark-gray opacity-50 mb-[5px]">
              {data?.location?.phoneNumber}
            </div>
            <Divider className="m-0" />
            <div className="order-info-box__content-item d-flex space-between mt-[15px]">
              <div>{t('ordersTabTryBuy.deliveryPartner')}</div>
              <div className="fw-600 color-dark-gray">
                {data?.deliveryType === 'EXTERNAL'
                  ? 'Other'
                  : data?.shippingCarrier?.name || 'N/A'}
              </div>
            </div>
            <div className="order-info-box__content-item d-flex space-between mt-[15px]">
              <div>{t('orders.shippingNo')}</div>
              <a
                className="fw-600 color-dark-gray"
                href={data?.orderShipping?.trackingUrl}
                target="_blank"
                rel="noreferrer"
              >
                {data?.deliveryCode ? `#${data?.deliveryCode}` : '-'}
              </a>
            </div>
          </div>
        </div>
      </Card>
      <Card title={t('orderDetail.utm')}>
        <Space size={15} direction="vertical" className="w-full">
          <TotalOrderItem
            boldValue
            title={t('orders.utmId')}
            value={data?.utm?.utm_id || '-'}
          />
          <TotalOrderItem
            boldValue
            title={t('orders.source')}
            value={data?.utm?.utm_source || '-'}
          />
          <TotalOrderItem
            boldValue
            title={t('orders.medium')}
            value={data?.utm?.utm_medium || '-'}
          />
          <TotalOrderItem
            boldValue
            title={t('orders.name')}
            value={data?.utm?.utm_campaign || '-'}
          />
          <TotalOrderItem
            boldValue
            title={t('orders.term')}
            value={data?.utm?.utm_term || '-'}
          />
          <TotalOrderItem
            boldValue
            title={t('orders.content')}
            value={data?.utm?.utm_content || '-'}
          />
          <TotalOrderItem
            boldValue
            title={t('orders.landingSite')}
            value={data?.utm?.utm_landing || '-'}
          />
          <TotalOrderItem
            boldValue
            title={t('orders.referingSite')}
            value={data?.utm?.utm_referring || '-'}
          />
        </Space>
      </Card>
    </Space>
  );
};

export default RightContent;
